import Vue from 'vue';
import Vuex from 'vuex';
import firebase from '@/firebase.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categoriesLoaded: false,
    categories: {},
    awardsLoaded: false,
    awards: {},
    associationsLoaded: false,
    associations: {}
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories;
    },
    categoriesLoaded(state, loaded) {
      state.categoriesLoaded = loaded;
    },
    setAwards(state, awards) {
      state.awards = awards;
    },
    awardsLoaded(state, loaded) {
      state.awardsLoaded = loaded;
    },
    setAssociations(state, associations) {
      state.associations = associations;
    },
    associationsLoaded(state, loaded) {
      state.associationsLoaded = loaded;
    }
  },

  actions: {
    getCategories(context) {
      context.commit('categoriesLoaded', false);
      firebase.database().ref('categories').once('value').then((snapshot) => {
        context.commit('setCategories', snapshot.val());
        context.commit('categoriesLoaded', true);
      });
    },
    getAwards(context) {
      context.commit('awardsLoaded', false);
      firebase.database().ref('awards').once('value').then((snapshot) => {
        context.commit('setAwards', snapshot.val());
        context.commit('awardsLoaded', true);
      });
    },
    getAssociations(context) {
      context.commit('associationsLoaded', false);
      firebase.database().ref('associations').once('value').then((snapshot) => {
        context.commit('setAssociations', snapshot.val());
        context.commit('associationsLoaded', true);
      });
    }
  },

  getters: {
    categoriesSelect(state) {
      var selectItems = [];
      Object.keys(state.categories).forEach((catKey) => {
        selectItems.push({
          text: state.categories[catKey].categoryName,
          value: catKey
        });
      });
      return selectItems;
    },
    awardsSelect(state) {
      var selectItems = [];
      Object.keys(state.awards).forEach((awardKey) => {
        selectItems.push({
          text: state.awards[awardKey].awardName,
          value: awardKey
        });
      });
      return selectItems;
    }
  }
});
